import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>அங்குரம்</h1>
<h3><a>தாத்பர்யம்</a></h3>
 <div class="div3">				  

<span style="color:Blue;">
தாத்பர்யம் - விளக்கம்:
முளைவிடும் விதைக்கு அங்குரம்
என்று பெயர். ப்ரஹ்மச்சாரியாக
கலைகளை கற்க ஆரம்பிக்கும்
மாணவன் ஒரு பயிர், அதுபோல்
சம்சாhர சாகரத்தில் அடியெடுத்து 
வைக்கும் இந்த தம்பதிகளின்
உறவு என்ற பந்தம் தற்போது
முளைவிட ஆரம்பிக்கிறது. எனவே
இந்த உறவு நல்லவிதமாக பல்கிப்
பெருகி வளரவேண்டுமென்பதற்காக
ஓஷதி எனும் வேத மந்திரங்களை
ஜபித்து ப்ரஹ்மா, இந்த்ரன், யமன்
வருணன், ஸோமன் ஆகிய சக்தி
மிக்க தேவதைகளையும் அவர்கள்
பரிவாரங்களையும் ஆவாஹனம்
செய்து ஜபித்த பாலிகையை அவர்
கள் ஸந்நிதியில் சேர்த்து இந்த
தம்பதிகளுக்கு அவர்களுடைய
பரிபூரண அனுக்ரஹம் கிடைக்கப்
ப்ரார்திக்கப்படுகிறது. </span>

</div>

<h3><a>தேவையான வைதீக சாமான்கள்</a></h3>
        <div class="div3">
        உபநயனத்திற்கு அல்லது 
விவாஹத்திற்கு மட்டுமே அங்குரம் செய்யப்படும். இதற்காகத் தனியாக எதுவும் சாமான் தேவையில்லை.
ஐந்து பாலிகை மடக்குகள் மற்றும் முளைக்க வைத்த தானியங்கள் கொஞ்சம் பால் இவை மட்டுமே ப்ரத்யேகமாகத் தேவை. 
        </div>


<h3>காரிகை -01 </h3>
<div class="div3">
<img src= "assets/img/anguram2-l.jpg" class="img1" />
சௌளம், உபநயனம், விவாஹம் இம்மூன்று கர்மாவில் அங்குரம் செய்யவேண்டியது. 
சௌளமும், உபநயனமும் சேர்ந்தாற்போலத்தான் தற்காலம் நடக்கிறது. சௌளம் தனியாகச் 
செய்தால் அங்குரம் செய்துதான் சௌளம் செய்ய வேண்டியது.

ப்ராணாயாமம் முன் விவரித்திருக்;கிறபடி செய்து ஸ்ரீ பகவதாக்ஞா கைங்கர்யம், நக்ஷத்ரே ராசௌ 
ஜாதஸ்ய கோத்ரஸ்ய சர்மண: (மம) குமாரஸ்ய சௌளோபநயன கர்மாங்கம் அங்குரார்ப்பண கர்ம 
கரிஷ்யாமி (என்று உபநயனத்திலும் - கோத்ரஸ்ய சர்மண: வரஸ்ய கோத்ராய: நாம்நீயா: கன்னிகாயாச்ச 
உபயோ: உத்வாஹகர்மாங்கம் அங்குரார்பண கர்;ம கரிஷ்யாமி என்று விவாஹத்திலும்) இரண்டு தரம் சொல்லி 
தத்அங்கம புண்யாகவாசனம் கரிஷ்யே என்று சொல்லி இடுக்கு தர்ப்பத்தை வடக்கே சேர்க்கவும்.

புண்ணியாகவாசனம் கிரமப்படி செய்யவும். படியில் நெல்லில் கிழக்கு நுனியாக இரண்டு தர்ப்;பம் நடுவில்
 சேர்த்து பிறகு வடக்கு நுனியாக இரண்டு தர்ப்பம் சேர்த்து, 5 பாலிகைகளைக்கும் சந்தனம் ப10சி தேங்காய்நார்
  துவாரத்தில் அடைத்து மேல் அரசு, புரசு, மாஇலைகளை கிழக்கு நுனியாக சேர்த்து, புத்து மண் மேல் சேர்த்து, 
  சந்தனம், புஷ்பம், சோபனாக்ஷதையும் சேர்த்;து, நடுவில் 1, கிழக்கில் 1, தெற்கில் 1, மேற்கில் 1, வடக்கில் 1,
   மேற்படி தர்ப்பங்களில் வைக்கவேண்டும்.

முதல்நாளே நெல்லு, யவை, (வால்கோதுமை என்றும் நெல்லில் ஒருவிதமும் என்கிறார்கள். 
அது எங்கு கிடைக்கும் என்று தெரியவில்லை.) இங்கு பழக்கம், நெல்லு, உளுந்து, எள்ளு, பயறு, 
கடுகு இவைகளை ஊரவைக்கவேண்டும். பசும் பாலில் கலந்து பெரிய மடக்கில வைத்துக்கொள்ளவும்.
 புண்ணியாகவாசன தீர்த்தத்தால் 5 பாலிகைகள், பாலில் கலந்த மடக்கிலுள்ள ஓஷதி த்ரவ்யம், இவைகளை ப்ரோக்ஷக்கவும்.

கூர்ச்சத்தை வலது கையிலும், இடது கையில் சோபனாக்ஷதையையும் வைத்துக் கொள்ளவும். 
</div>


<div class="div3">
<img src="assets/img/paligaiyiduthal-L.jpg" class="img1"/>(1) பாலிகை நடுவில் உள்ளதில்; ஓம் பூ: ப்ரஹ்மாணம் ஆவாஹயாமி, ஓம்புவ: ப்ரஜாபதிம் ஆவாஹயாமி, 
ஓம்ஸுவ: சதுர்முகம் ஆவாஹயாமி, ஓம்ப10ர்புவஸ்ஸுவ: ஹிரண்யகர்;ப்பம் ஆவாஹயாமி, ப்ரம்ஹாதிப்யோ 
நம: ப்ரம்ஹாதீநாம்இதம் ஆஸனம். 

(2) கிழக்கிலுள்ள பாலிகையில் ஓம்ப10: இந்த்ரம் ஆவாஹயாமி, ஓம்புவ வஜ்ரிணம் ஆவாஹயாமி, ஓம்ஸுவ: 
சதக்ருதும்; ஆவாஹயாமி, ஓம்ப10ர்புவஸ்ஸுவ: சசீபதீம் ஆவாஹயாமி, இந்த்ராதிப்யோநம: இந்த்ராதீனாம் இதமாஸனம்.

(3) தெற்கே உள்ள பாலிகையில், ஓம்ப10: யமம் ஆவாஹயமி வைவஸ்வதம் ஆவாஹயாமி, ஓம் ஸுவ: 
பித்ருபதிம் ஆவாஹாயாமி ஓம்புர்புவஸ்ஸுவ: தர்மராஜம் ஆவாஹயாமி, யமாதிப்யோ நம: யமாதீனாம்; இதமாஸனம் 

(4) மேற்கேயுள்ள பாலிகையில் ஓம்ப10: வருணம் ஆவாஹயாமி ஓம்புவ: ப்ரசேதஸம் ஆவாஹயாமி ஓம்ஸுவ: 
ஸுரூபிணம் ஆவாஹயாமி, ஓம்ப10ர்புவஸ்ஸுவ: அபாம்பதிம் ஆவாஹயாமி வருணாதிப்யோ நம: வருணாதீனாம் இதம் ஆஸனம்.

(5) வடக்கே உள்ள பாலிகையில் ஓம்ப10: ஸோமம் ஆவாஹயாமி ஓம்புவ: இந்தும்; ஆவாஹயாமி, ஓம் ஸுவ: 
நிசாகரம் ஆவாஹயாமி, ஓம்ப10ர்புவஸ்ஸுவ: ஓஷதீசம் ஆவாஹயாமி, ஸோமாதிப்யோ நம: ஸோமாதீனாம் இதமாஸனம்.

ப்ரம்ஹேந்த்ர யம வருண ஸோமாதிகள் ஒவ்வொருவருக்கும் ஆஸனம் முதல் எல்லாவித உபசாரங்களும் வேஷ்டி 
உட்பட சாத்தி (நிவேதன தாம்ப10லம், ஸுவர்ண புஷ்பம், மந்த்ர புஷ்பம் முதலியவைகள் செய்து) மடக்கிலுள்ள 
பால் கலந்த ஓஷதி த்ரவ்யங்கள் மேல்கூர்ச்சத்தை வைத்துக்கொண்டு, மடக்கை எடுத்து நின்று ஃ உட்கார்ந்து கொண்டு பின்வரும் வாக்கியங்களைச் சொல்லவும்.
</div>



<h3>காரிகை -02</h3>

<ion-row><ion-col>காரிகை 
திசாம்பதீந் நமஸ்யாமி ஸர்வகாம பலப்ரதாந் குர்வந்து ஸபலம் கர்ம குர்வந்து ஸததம் சுபம் 
(வ்ரீயவ மாஷ தில முத்க ஸர்ஷபாந் மிச்ரீக்ருத்ய க்ஷிரேண ப்ரக்ஷhல்ய) என்று சொல்லி, 
ஓஷதீஸூக்த ஜபகர்மணி ஸர்வேயோ ஸ்ரீ வைஷ்ணவேப்யோ நம: என்று சோபனாக்ஷதையை ஸ்வாமிகள் பேரில் சேர்க்கவும். 
</ion-col>
</ion-row>
<ion-row><ion-col >
(ஓஷதீ சூக்தம் ஒலி இங்கு இணைப்பு பிறகு வழங்கப்படும். தேவையானால் தள மேலாளரைத் தொடர்பு கொள்க)
</ion-col>
</ion-row>
<ion-row><ion-col>
ஓஷதயஸ்ஸம்வதந்தே ஸோமேநஸஹ ராக்ஞா யஸ்மைகரோதி ப்ராம்ஹணஸ் தகும்ராஜந் பாரயாமஸி" என்று ஜபம் முடியும். 

இது வரையில் உட்கார்ந்து கொண்டு மடக்கிலுள்ள பாலிகை சாமான்களை கூர்ச்சத்துடன் 
தொட்டுக் கொண்டிருக்க வேணும். 'பீஜாவாபந முஹ_ர்த்தஸ் ஸுமுஹ_ர்த்தோஸ்து இதிபவந்த: 
மஹாந்த: அனுக்ருண்ணந்து" என்று ப்ரார்த்திக்க 'ஸுமுஹ_ர்த்தோஸ்து" என்று பதில். ஜபதக்ஷிணை கொடுக்கவேணும்.
</ion-col>
</ion-row>
<ion-row><ion-col>
ஒருதரம் மந்திரத்துடனும் இரண்டு தடவை மந்திரமில்லாமலும், மடக்கிலுள்ள ஓஷதீ த்ரவ்யத்தை கூர்ச்ச ஸஹிதம்; 5 பாலிகைகளிலும் சேர்க்கவேணும்.
</ion-col>
</ion-row>
<ion-row><ion-col>
(1) நடுபாலிகையில் 'ப்ரும்ஹஜக்ஞாநம் - ப்ரதமம் - புரஸ்தாத் - விஸீமத: - ஸுருச: - வேநஆவ: - 
ஸபுத்நியா: - உபாமா: அஸ்யவிஷ்டா: - ஸதச்சயோநிம் - அஸதச்சவிவ:‚ பிதாவிராஜாம் ருஷபோராயீணாம் - 
அந்தரிக்ஷம் - விச்வ ரூப - ஆவிவேச - தமர்கை: - அப்யர்சந்தி - வத்ஸம் - ப்ரம்ஹ ஸந்தம் - ப்ரம்ஹணா - 
வர்த்தயந்த:‚‚ ப்ரம்ஹாதிப்யோ நம: அயம்பீஜாவபாப:" 
ஸக்ருந்மந்தரேண த்வி: தூஷ்ணீம்.
</ion-col>
</ion-row>
 <ion-row><ion-col>
(2) கிழக்குபாலிகையில் 'யதஇந்த்ர - பயாமஹே - ததோந: - அபயம்க்ருதி - மகவந்சக்தி - தவதந்ந: - 
ஊதயே வித்விஷ: - விம்ருதோஜஹி ‚ ஸ்வஸ்திதா: - விசஸ்பதி: - வ்ருத்ரஹ - விம்ருதோவசீ - வ்ருஷேந்த்ர: -
 புரயேதுந: - ஸ்வஸ்திதா: - அபயம்கர:‚‚ இந்த்ராதிப்யோநம: அயம்பீஜாவாப:" ஸக்ருமந்த்ரேண த்வி: தூஷ்ணீம்,
</ion-col>
</ion-row>
<ion-row><ion-col>
(3) தெற்கு பாலிகையில் 'யோஸ்யகௌஷட்ய - ஜகத: - பார்த்திவஸ்ய - ஏக - இத்வசீ - யமம் - பங்யச்ரவ: - காய - 
யோராஜா - அநபரோட்;ய: - யமம்காய - பங்க்யச்ரவ: - யோராஜா - அந பரோட்ய: - யேநாப: - நத்ய: - தந்வாநி - 
யேநத்யவ்ஹ்: - ப்ருத்வீத்ருடா‚‚ யமாதிப்யோ நம: அயம்பீஜாவாப:" ஸக்ருந்மந்த்ரணே: த்வி: தூஷ்ணீம்.
</ion-col>
</ion-row>
<ion-row><ion-col>
(4) மேற்குபாலிகையில் 'இமம்மேவருண - ச்ருதீ ஹவம் - அத்யாசம்ருடய - த்வாமவஸ்யு: - ஆசகே‚ தத்வயாயாமி - 
ப்ரம்;ஹணா - வந்தமாந: - ததாசாஸ்தே - யஜமாந: - ஹவிர்பி: - அஹேடமாந: - வருண - இஹபோதி - உருசகும்ஸமாந:
- ஆயு: - ப்ரமோஷீ:‚‚ வருணாதிப்யோநம: அயம் பீஜாவாப: ஸக்ருந்மந்த்ரேணத்வி. தூஷ்ணீம்.
</ion-col>
</ion-row>
<ion-row><ion-col>
(5) வடக்கு பாலிகையில் 'ஸோமோதேநும் - ஸோம: - அர்வந்தம் - ஆசும் - ஸோமோவீரம் - கர்மண்யம் - ததாது 
- ஸாதந்யம் - விதத்யம் ஸபேயம் - பிதுச்ரவணம் யோததாசது - அஸ்மை‚ ஆப்யாயஸ்வ - ஸமேதுதே - விச்வத: - 
ஸோமவ்ருஷ்ணியம் - பவாவாஜஸ்ய - ஸங்கதே‚‚ ஸோமாதிப்யோநம: அயம் பீஜாவாப." ஸக்ருந்மந்த்ரேணத்வி தூஷ்ணீம்.
</ion-col>
</ion-row> -->
<ion-row><ion-col>
பிறகு ஓம் ஓம் என்று 1 முதல் 5 பாலிகைகளையும் கையில் கூர்;சத்துடன் வரிசைக்ரமமாகச் தொட்டுச் சொல்லவும். 
பிறகு 3 அல்லது ஐந்து சுமங்கலிகளை கூப்பிட்டு , 1 முதல் 5பாலிகைகளிலும் வரிசை க்ரமமாக மடக்கிலிருந்து ஜலம்
 மூன்று தடவை சேர்க்கச் செய்து ஆத்திலுள்ள பெருமாள் சன்னதிக்கருகில் ஸ்தலசுத்தி செய்து கோலம் போட்டு அதன்மேல் 
 கொஞ்சம் நெல் சேர்த்து இந்த 5 பாலிகைகளிலும் கொஞ்சம் மண் சேர்த்து அங்கு வைத்து 4 நாள் கல்லியாணம் முடியும் 
 வரையில் காலையிலும் மாலையிலும் தளிகை ஸமர்ப்பித்து தீர்த்தம் கொஞ்சம் சேர்க்கிற பழக்கம். மெழுகாத கூடையால் 
 மூடி வைக்கிற பழக்கம். கல்யாணம் முடிந்த பிறகு மேற்படி பாலிகைகளிலுள்ள பயிர்களை, நதியிலோ தடாகங்களிலோ 
 சேர்க்கிற பழக்கம். மேற்படி 5 பாலிகைகளையும் க்ருஹத்தில் ஒரு கயற்றில் கோத்து அநேகமாக மாட்டுக்கொட்டிலில் 
 அல்லது வேரிடத்திலோ கட்டிவைப்பது பழக்கம். ஆனால் தற்போது, உபநயனம் ஃ விவாஹத்தில் முத்தாலத்தி 
 எடுக்கும்போது இந்த பாலிகைக்கும் காட்டி விட்டு பாலிகையை உடனேயே யதாஸ்தானம் பண்ணிவிட்டு மஞ்சநீர் 
 எடுத்ததும் வயதுக்கு வராத இரண்டு கன்னிப் பெண் குழந்தைகள் மற்றும் சுமங்கலிகள் உபநயன ஃ விவாஹ 
 பெண் பிள்ளைகள் ஸஹிதம் ஒரு பாத்திரத்தில் நிறைய தீர்த்தம் வைத்துக் கொண்டு அதில் கரைத்துவிட்டு, 
 அதை நடுவில் வைத்து அதைச் சுற்றிவந்து கும்மி அடித்து குதித்துப் பாடுவது நீண்ட நாட்களாக வழக்கத்திலிருக்கிறது. 
</ion-col>
</ion-row>`;

const AnkuramPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="அங்குரம்  - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default AnkuramPage;
